// reason_picker — multi-select reasons (+ optional "other" text), saved to write_to.
import React, { useState } from 'react';
import { ListChecks } from 'lucide-react';
import { StepCard, StepNav } from './_stepKit';

export default function ReasonPicker({ action, value, onChange, onNext, onBack, canBack }) {
  const p = action.params || {};
  const options = String(p.options || '').split(',').map((s) => s.trim()).filter(Boolean);
  const allowOther = String(p.allow_other ?? 'false').toLowerCase() === 'true' || p.allow_other === true;
  const [picked, setPicked] = useState(value?.reasons || []);
  const [other, setOther] = useState(value?.other || '');

  const emit = (reasons, oth) => onChange({ reasons, other: oth, text: [...reasons.filter((r) => r !== 'Other'), oth].filter(Boolean).join('; ') });
  const toggle = (o) => { const next = picked.includes(o) ? picked.filter((x) => x !== o) : [...picked, o]; setPicked(next); emit(next, other); };
  const showOther = allowOther && (picked.includes('Other') || !options.includes('Other'));

  return (
    <div>
      <StepCard icon={ListChecks} title="Reasons" testid="wf-reason-picker">
        {p.prompt && <div className="text-sm text-slate-600">{p.prompt}</div>}
        <div className="flex flex-wrap gap-2">
          {options.map((o, i) => (
            <button key={o} type="button" onClick={() => toggle(o)} data-testid={`wf-reason-option-${i}`}
              className={`px-3 py-1.5 rounded-full text-sm border transition-colors ${picked.includes(o) ? 'bg-sky-600 border-sky-600 text-white' : 'bg-white border-slate-300 text-slate-700 hover:border-sky-400'}`}>
              {o}
            </button>
          ))}
        </div>
        {showOther && (
          <input value={other} onChange={(e) => { setOther(e.target.value); emit(picked, e.target.value); }} data-testid="wf-reason-other"
            className="w-full border border-slate-300 rounded px-3 py-2 text-sm" placeholder="Other reason (optional)" />
        )}
      </StepCard>
      <StepNav canBack={canBack} onBack={onBack} onNext={onNext} disabled={picked.length === 0 && !other.trim()} />
    </div>
  );
}
